import lazyLoad from '@helper/lazy-load'

const router = [
    {
        path: '/app/industry',
        element: lazyLoad(() => import('@pages/industry/components/main')),
        loader: () => ({
            // menuIndex: 5,
            key: 'industry.industry',
            icon: 'icon-nav-DataOrigin1',
            show: true
        })
    }
]

export default router
